import { z } from 'zod';

// Shape of one saved tab bar entry as the backend returns it. Not the same as
// the tab bar *form's* schema (`4-tab-bar-config.schema.ts`), which validates
// merchant input and rewrites links before submission.
export const onboardingTabConfigSchema = z.object({
  key: z.string(),
  title: z.string(),
  path: z.string(),
  iconKey: z.string(),
});

// Mirrors backend's `TenantCreationRequestDto`
// (backend/src/controllers/tenant-creation-request.controller.ts). The GET
// response is parsed against this at the API boundary instead of being
// trusted as-is: the onboarding route guards read `tabs` straight from it,
// and a field the backend silently stopped (or never started) sending used to
// surface only as the flow bouncing the merchant back a step with no error.
export const tenantCreationRequestSchema = z.object({
  id: z.string(),
  slug: z.string(),
  fromShopifyAppStore: z.boolean(),
  stage: z.string(),
  estimatedCompletionDateIso: z.string().nullable(),

  isSubscriptionPaidFor: z.boolean(),

  appName: z.string().nullable(),
  appContactEmail: z.string().nullable(),
  storeName: z.string().nullable(),
  storeUrl: z.string().nullable(),
  contactPhone: z.string().nullable(),
  storePrivacyPolicyUrl: z.string().nullable(),
  storePlatform: z.string().nullable(),
  storeFtpHost: z.string().nullable(),
  storeFtpUsername: z.string().nullable(),
  storeFtpPassword: z.string().nullable(),
  appIconUrl: z.string().nullable(),
  appIconBackgroundColor: z.string().nullable(),
  splashScreenUrl: z.string().nullable(),
  splashScreenBackgroundColor: z.string().nullable(),
  statusBarTheme: z.enum(['light', 'dark']).nullable(),
  shopifyCollaboratorAccessCode: z.string().nullable(),
  isShopifyIntegrationConfigured: z.boolean(),

  tenantSlug: z.string().nullable(),

  websiteBannerEnabled: z.boolean().nullable(),
  websiteBannerText: z.string().nullable(),
  websiteBannerButtonText: z.string().nullable(),
  websiteBannerBackgroundColor: z.string().nullable(),
  websiteBannerForegroundColor: z.string().nullable(),

  // In display order; empty until the merchant saves the tab bar step.
  tabs: z.array(onboardingTabConfigSchema),
  accentColor: z.string().nullable(),
  notificationPreviewTitle: z.string().nullable(),
  notificationPreviewBody: z.string().nullable(),
});

export type OnboardingTabConfig = z.infer<typeof onboardingTabConfigSchema>;
export type TenantCreationRequest = z.infer<typeof tenantCreationRequestSchema>;
